// Sentry must be imported first so it can patch global error handling
import { reportError } from './instrument.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary onError={reportError}>
            <App />
        </ErrorBoundary>
    </React.StrictMode>,
);
